export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-doublechancelotto.vue?vue&type=template&id=6bf71071"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-doublechancelotto.vue?vue&type=template&id=6bf71071
// module id = vuKI
// module chunks = 0